import {FC} from 'react'

import styles from './WhiteBoxWrapper.module.scss'

export const WhiteBoxWrapper: FC = ({children}) => {
  return <div className={styles.whiteBoxWrapper}>{children}</div>
}
